// Shared ISO country calling-code list, used anywhere we need a phone
// country-code picker (Start a Session's partner phone field, the notify-me
// phone prompt, etc). Single source of truth so the two stay in sync.

export const COUNTRY_CODES = [
  { code: '+93', flag: '🇦🇫', name: 'Afghanistan', iso: 'AF', aliases: ['AF'] },
  { code: '+355', flag: '🇦🇱', name: 'Albania', iso: 'AL', aliases: ['AL'] },
  { code: '+213', flag: '🇩🇿', name: 'Algeria', iso: 'DZ', aliases: ['DZ'] },
  { code: '+1684', flag: '🇦🇸', name: 'American Samoa', iso: 'AS', aliases: ['AS'] },
  { code: '+376', flag: '🇦🇩', name: 'Andorra', iso: 'AD', aliases: ['AD'] },
  { code: '+244', flag: '🇦🇴', name: 'Angola', iso: 'AO', aliases: ['AO'] },
  { code: '+1264', flag: '🇦🇮', name: 'Anguilla', iso: 'AI', aliases: ['AI'] },
  { code: '+1268', flag: '🇦🇬', name: 'Antigua and Barbuda', iso: 'AG', aliases: ['AG'] },
  { code: '+54', flag: '🇦🇷', name: 'Argentina', iso: 'AR', aliases: ['AR'] },
  { code: '+374', flag: '🇦🇲', name: 'Armenia', iso: 'AM', aliases: ['AM'] },
  { code: '+297', flag: '🇦🇼', name: 'Aruba', iso: 'AW', aliases: ['AW'] },
  { code: '+61', flag: '🇦🇺', name: 'Australia', iso: 'AU', aliases: ['AU'] },
  { code: '+43', flag: '🇦🇹', name: 'Austria', iso: 'AT', aliases: ['AT'] },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan', iso: 'AZ', aliases: ['AZ'] },
  { code: '+1242', flag: '🇧🇸', name: 'Bahamas', iso: 'BS', aliases: ['BS'] },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain', iso: 'BH', aliases: ['BH'] },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh', iso: 'BD', aliases: ['BD'] },
  { code: '+1246', flag: '🇧🇧', name: 'Barbados', iso: 'BB', aliases: ['BB'] },
  { code: '+375', flag: '🇧🇾', name: 'Belarus', iso: 'BY', aliases: ['BY'] },
  { code: '+32', flag: '🇧🇪', name: 'Belgium', iso: 'BE', aliases: ['BE'] },
  { code: '+501', flag: '🇧🇿', name: 'Belize', iso: 'BZ', aliases: ['BZ'] },
  { code: '+229', flag: '🇧🇯', name: 'Benin', iso: 'BJ', aliases: ['BJ'] },
  { code: '+1441', flag: '🇧🇲', name: 'Bermuda', iso: 'BM', aliases: ['BM'] },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan', iso: 'BT', aliases: ['BT'] },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia', iso: 'BO', aliases: ['BO'] },
  { code: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina', iso: 'BA', aliases: ['BA'] },
  { code: '+267', flag: '🇧🇼', name: 'Botswana', iso: 'BW', aliases: ['BW'] },
  { code: '+55', flag: '🇧🇷', name: 'Brazil', iso: 'BR', aliases: ['BR'] },
  { code: '+246', flag: '🇮🇴', name: 'British Indian Ocean Territory', iso: 'IO', aliases: ['IO'] },
  { code: '+1284', flag: '🇻🇬', name: 'British Virgin Islands', iso: 'VG', aliases: ['VG'] },
  { code: '+673', flag: '🇧🇳', name: 'Brunei', iso: 'BN', aliases: ['BN'] },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria', iso: 'BG', aliases: ['BG'] },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso', iso: 'BF', aliases: ['BF'] },
  { code: '+257', flag: '🇧🇮', name: 'Burundi', iso: 'BI', aliases: ['BI'] },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia', iso: 'KH', aliases: ['KH'] },
  { code: '+237', flag: '🇨🇲', name: 'Cameroon', iso: 'CM', aliases: ['CM'] },
  { code: '+1', flag: '🇨🇦', name: 'Canada', iso: 'CA', aliases: ['CA'] },
  { code: '+238', flag: '🇨🇻', name: 'Cape Verde', iso: 'CV', aliases: ['CV'] },
  { code: '+1345', flag: '🇰🇾', name: 'Cayman Islands', iso: 'KY', aliases: ['KY'] },
  { code: '+236', flag: '🇨🇫', name: 'Central African Republic', iso: 'CF', aliases: ['CF'] },
  { code: '+235', flag: '🇹🇩', name: 'Chad', iso: 'TD', aliases: ['TD'] },
  { code: '+56', flag: '🇨🇱', name: 'Chile', iso: 'CL', aliases: ['CL'] },
  { code: '+86', flag: '🇨🇳', name: 'China', iso: 'CN', aliases: ['CN'] },
  { code: '+57', flag: '🇨🇴', name: 'Colombia', iso: 'CO', aliases: ['CO'] },
  { code: '+269', flag: '🇰🇲', name: 'Comoros', iso: 'KM', aliases: ['KM'] },
  { code: '+243', flag: '🇨🇩', name: 'Congo (DRC)', iso: 'CD', aliases: ['CD', 'DRC', 'CONGO'] },
  { code: '+242', flag: '🇨🇬', name: 'Congo (Republic)', iso: 'CG', aliases: ['CG'] },
  { code: '+682', flag: '🇨🇰', name: 'Cook Islands', iso: 'CK', aliases: ['CK'] },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica', iso: 'CR', aliases: ['CR'] },
  { code: '+385', flag: '🇭🇷', name: 'Croatia', iso: 'HR', aliases: ['HR'] },
  { code: '+53', flag: '🇨🇺', name: 'Cuba', iso: 'CU', aliases: ['CU'] },
  { code: '+599', flag: '🇨🇼', name: 'Curaçao', iso: 'CW', aliases: ['CW'] },
  { code: '+357', flag: '🇨🇾', name: 'Cyprus', iso: 'CY', aliases: ['CY'] },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic', iso: 'CZ', aliases: ['CZ', 'CZECHIA'] },
  { code: '+225', flag: '🇨🇮', name: 'Côte d\'Ivoire', iso: 'CI', aliases: ['CI'] },
  { code: '+45', flag: '🇩🇰', name: 'Denmark', iso: 'DK', aliases: ['DK'] },
  { code: '+253', flag: '🇩🇯', name: 'Djibouti', iso: 'DJ', aliases: ['DJ'] },
  { code: '+1767', flag: '🇩🇲', name: 'Dominica', iso: 'DM', aliases: ['DM'] },
  { code: '+1809', flag: '🇩🇴', name: 'Dominican Republic', iso: 'DO', aliases: ['DO'] },
  { code: '+593', flag: '🇪🇨', name: 'Ecuador', iso: 'EC', aliases: ['EC'] },
  { code: '+20', flag: '🇪🇬', name: 'Egypt', iso: 'EG', aliases: ['EG'] },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador', iso: 'SV', aliases: ['SV'] },
  { code: '+240', flag: '🇬🇶', name: 'Equatorial Guinea', iso: 'GQ', aliases: ['GQ'] },
  { code: '+291', flag: '🇪🇷', name: 'Eritrea', iso: 'ER', aliases: ['ER'] },
  { code: '+372', flag: '🇪🇪', name: 'Estonia', iso: 'EE', aliases: ['EE'] },
  { code: '+268', flag: '🇸🇿', name: 'Eswatini', iso: 'SZ', aliases: ['SZ'] },
  { code: '+251', flag: '🇪🇹', name: 'Ethiopia', iso: 'ET', aliases: ['ET'] },
  { code: '+500', flag: '🇫🇰', name: 'Falkland Islands', iso: 'FK', aliases: ['FK'] },
  { code: '+298', flag: '🇫🇴', name: 'Faroe Islands', iso: 'FO', aliases: ['FO'] },
  { code: '+679', flag: '🇫🇯', name: 'Fiji', iso: 'FJ', aliases: ['FJ'] },
  { code: '+358', flag: '🇫🇮', name: 'Finland', iso: 'FI', aliases: ['FI'] },
  { code: '+33', flag: '🇫🇷', name: 'France', iso: 'FR', aliases: ['FR'] },
  { code: '+594', flag: '🇬🇫', name: 'French Guiana', iso: 'GF', aliases: ['GF'] },
  { code: '+689', flag: '🇵🇫', name: 'French Polynesia', iso: 'PF', aliases: ['PF'] },
  { code: '+241', flag: '🇬🇦', name: 'Gabon', iso: 'GA', aliases: ['GA'] },
  { code: '+220', flag: '🇬🇲', name: 'Gambia', iso: 'GM', aliases: ['GM'] },
  { code: '+995', flag: '🇬🇪', name: 'Georgia', iso: 'GE', aliases: ['GE'] },
  { code: '+49', flag: '🇩🇪', name: 'Germany', iso: 'DE', aliases: ['DE'] },
  { code: '+233', flag: '🇬🇭', name: 'Ghana', iso: 'GH', aliases: ['GH'] },
  { code: '+350', flag: '🇬🇮', name: 'Gibraltar', iso: 'GI', aliases: ['GI'] },
  { code: '+30', flag: '🇬🇷', name: 'Greece', iso: 'GR', aliases: ['GR'] },
  { code: '+299', flag: '🇬🇱', name: 'Greenland', iso: 'GL', aliases: ['GL'] },
  { code: '+1473', flag: '🇬🇩', name: 'Grenada', iso: 'GD', aliases: ['GD'] },
  { code: '+590', flag: '🇬🇵', name: 'Guadeloupe', iso: 'GP', aliases: ['GP'] },
  { code: '+1671', flag: '🇬🇺', name: 'Guam', iso: 'GU', aliases: ['GU'] },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala', iso: 'GT', aliases: ['GT'] },
  { code: '+441481', flag: '🇬🇬', name: 'Guernsey', iso: 'GG', aliases: ['GG'] },
  { code: '+224', flag: '🇬🇳', name: 'Guinea', iso: 'GN', aliases: ['GN'] },
  { code: '+245', flag: '🇬🇼', name: 'Guinea-Bissau', iso: 'GW', aliases: ['GW'] },
  { code: '+592', flag: '🇬🇾', name: 'Guyana', iso: 'GY', aliases: ['GY'] },
  { code: '+509', flag: '🇭🇹', name: 'Haiti', iso: 'HT', aliases: ['HT'] },
  { code: '+504', flag: '🇭🇳', name: 'Honduras', iso: 'HN', aliases: ['HN'] },
  { code: '+852', flag: '🇭🇰', name: 'Hong Kong', iso: 'HK', aliases: ['HK'] },
  { code: '+36', flag: '🇭🇺', name: 'Hungary', iso: 'HU', aliases: ['HU'] },
  { code: '+354', flag: '🇮🇸', name: 'Iceland', iso: 'IS', aliases: ['IS'] },
  { code: '+91', flag: '🇮🇳', name: 'India', iso: 'IN', aliases: ['IN'] },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia', iso: 'ID', aliases: ['ID'] },
  { code: '+98', flag: '🇮🇷', name: 'Iran', iso: 'IR', aliases: ['IR'] },
  { code: '+964', flag: '🇮🇶', name: 'Iraq', iso: 'IQ', aliases: ['IQ'] },
  { code: '+353', flag: '🇮🇪', name: 'Ireland', iso: 'IE', aliases: ['IE'] },
  { code: '+441624', flag: '🇮🇲', name: 'Isle of Man', iso: 'IM', aliases: ['IM'] },
  { code: '+972', flag: '🇮🇱', name: 'Israel', iso: 'IL', aliases: ['IL'] },
  { code: '+39', flag: '🇮🇹', name: 'Italy', iso: 'IT', aliases: ['IT'] },
  { code: '+1876', flag: '🇯🇲', name: 'Jamaica', iso: 'JM', aliases: ['JM'] },
  { code: '+81', flag: '🇯🇵', name: 'Japan', iso: 'JP', aliases: ['JP'] },
  { code: '+441534', flag: '🇯🇪', name: 'Jersey', iso: 'JE', aliases: ['JE'] },
  { code: '+962', flag: '🇯🇴', name: 'Jordan', iso: 'JO', aliases: ['JO'] },
  { code: '+7', flag: '🇰🇿', name: 'Kazakhstan', iso: 'KZ', aliases: ['KZ'] },
  { code: '+254', flag: '🇰🇪', name: 'Kenya', iso: 'KE', aliases: ['KE'] },
  { code: '+686', flag: '🇰🇮', name: 'Kiribati', iso: 'KI', aliases: ['KI'] },
  { code: '+383', flag: '🇽🇰', name: 'Kosovo', iso: 'XK', aliases: ['XK'] },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait', iso: 'KW', aliases: ['KW'] },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan', iso: 'KG', aliases: ['KG'] },
  { code: '+856', flag: '🇱🇦', name: 'Laos', iso: 'LA', aliases: ['LA'] },
  { code: '+371', flag: '🇱🇻', name: 'Latvia', iso: 'LV', aliases: ['LV'] },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon', iso: 'LB', aliases: ['LB'] },
  { code: '+266', flag: '🇱🇸', name: 'Lesotho', iso: 'LS', aliases: ['LS'] },
  { code: '+231', flag: '🇱🇷', name: 'Liberia', iso: 'LR', aliases: ['LR'] },
  { code: '+218', flag: '🇱🇾', name: 'Libya', iso: 'LY', aliases: ['LY'] },
  { code: '+423', flag: '🇱🇮', name: 'Liechtenstein', iso: 'LI', aliases: ['LI'] },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania', iso: 'LT', aliases: ['LT'] },
  { code: '+352', flag: '🇱🇺', name: 'Luxembourg', iso: 'LU', aliases: ['LU'] },
  { code: '+853', flag: '🇲🇴', name: 'Macau', iso: 'MO', aliases: ['MO'] },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar', iso: 'MG', aliases: ['MG'] },
  { code: '+265', flag: '🇲🇼', name: 'Malawi', iso: 'MW', aliases: ['MW'] },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia', iso: 'MY', aliases: ['MY'] },
  { code: '+960', flag: '🇲🇻', name: 'Maldives', iso: 'MV', aliases: ['MV'] },
  { code: '+223', flag: '🇲🇱', name: 'Mali', iso: 'ML', aliases: ['ML'] },
  { code: '+356', flag: '🇲🇹', name: 'Malta', iso: 'MT', aliases: ['MT'] },
  { code: '+692', flag: '🇲🇭', name: 'Marshall Islands', iso: 'MH', aliases: ['MH'] },
  { code: '+596', flag: '🇲🇶', name: 'Martinique', iso: 'MQ', aliases: ['MQ'] },
  { code: '+222', flag: '🇲🇷', name: 'Mauritania', iso: 'MR', aliases: ['MR'] },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius', iso: 'MU', aliases: ['MU'] },
  { code: '+262', flag: '🇾🇹', name: 'Mayotte', iso: 'YT', aliases: ['YT'] },
  { code: '+52', flag: '🇲🇽', name: 'Mexico', iso: 'MX', aliases: ['MX'] },
  { code: '+691', flag: '🇫🇲', name: 'Micronesia', iso: 'FM', aliases: ['FM'] },
  { code: '+373', flag: '🇲🇩', name: 'Moldova', iso: 'MD', aliases: ['MD'] },
  { code: '+377', flag: '🇲🇨', name: 'Monaco', iso: 'MC', aliases: ['MC'] },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia', iso: 'MN', aliases: ['MN'] },
  { code: '+382', flag: '🇲🇪', name: 'Montenegro', iso: 'ME', aliases: ['ME'] },
  { code: '+1664', flag: '🇲🇸', name: 'Montserrat', iso: 'MS', aliases: ['MS'] },
  { code: '+212', flag: '🇲🇦', name: 'Morocco', iso: 'MA', aliases: ['MA'] },
  { code: '+258', flag: '🇲🇿', name: 'Mozambique', iso: 'MZ', aliases: ['MZ'] },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar', iso: 'MM', aliases: ['MM'] },
  { code: '+264', flag: '🇳🇦', name: 'Namibia', iso: 'NA', aliases: ['NA'] },
  { code: '+674', flag: '🇳🇷', name: 'Nauru', iso: 'NR', aliases: ['NR'] },
  { code: '+977', flag: '🇳🇵', name: 'Nepal', iso: 'NP', aliases: ['NP'] },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands', iso: 'NL', aliases: ['NL'] },
  { code: '+687', flag: '🇳🇨', name: 'New Caledonia', iso: 'NC', aliases: ['NC'] },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand', iso: 'NZ', aliases: ['NZ'] },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua', iso: 'NI', aliases: ['NI'] },
  { code: '+227', flag: '🇳🇪', name: 'Niger', iso: 'NE', aliases: ['NE'] },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria', iso: 'NG', aliases: ['NG'] },
  { code: '+683', flag: '🇳🇺', name: 'Niue', iso: 'NU', aliases: ['NU'] },
  { code: '+850', flag: '🇰🇵', name: 'North Korea', iso: 'KP', aliases: ['KP', 'NORTH KOREA'] },
  { code: '+389', flag: '🇲🇰', name: 'North Macedonia', iso: 'MK', aliases: ['MK'] },
  { code: '+47', flag: '🇳🇴', name: 'Norway', iso: 'NO', aliases: ['NO'] },
  { code: '+968', flag: '🇴🇲', name: 'Oman', iso: 'OM', aliases: ['OM'] },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan', iso: 'PK', aliases: ['PK'] },
  { code: '+680', flag: '🇵🇼', name: 'Palau', iso: 'PW', aliases: ['PW'] },
  { code: '+970', flag: '🇵🇸', name: 'Palestine', iso: 'PS', aliases: ['PS'] },
  { code: '+507', flag: '🇵🇦', name: 'Panama', iso: 'PA', aliases: ['PA'] },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea', iso: 'PG', aliases: ['PG'] },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay', iso: 'PY', aliases: ['PY'] },
  { code: '+51', flag: '🇵🇪', name: 'Peru', iso: 'PE', aliases: ['PE'] },
  { code: '+63', flag: '🇵🇭', name: 'Philippines', iso: 'PH', aliases: ['PH'] },
  { code: '+48', flag: '🇵🇱', name: 'Poland', iso: 'PL', aliases: ['PL'] },
  { code: '+351', flag: '🇵🇹', name: 'Portugal', iso: 'PT', aliases: ['PT'] },
  { code: '+1787', flag: '🇵🇷', name: 'Puerto Rico', iso: 'PR', aliases: ['PR'] },
  { code: '+974', flag: '🇶🇦', name: 'Qatar', iso: 'QA', aliases: ['QA'] },
  { code: '+40', flag: '🇷🇴', name: 'Romania', iso: 'RO', aliases: ['RO'] },
  { code: '+7', flag: '🇷🇺', name: 'Russia', iso: 'RU', aliases: ['RU'] },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda', iso: 'RW', aliases: ['RW'] },
  { code: '+590', flag: '🇧🇱', name: 'Saint Barthélemy', iso: 'BL', aliases: ['BL'] },
  { code: '+1869', flag: '🇰🇳', name: 'Saint Kitts and Nevis', iso: 'KN', aliases: ['KN'] },
  { code: '+1758', flag: '🇱🇨', name: 'Saint Lucia', iso: 'LC', aliases: ['LC'] },
  { code: '+508', flag: '🇵🇲', name: 'Saint Pierre and Miquelon', iso: 'PM', aliases: ['PM'] },
  { code: '+1784', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines', iso: 'VC', aliases: ['VC'] },
  { code: '+685', flag: '🇼🇸', name: 'Samoa', iso: 'WS', aliases: ['WS'] },
  { code: '+378', flag: '🇸🇲', name: 'San Marino', iso: 'SM', aliases: ['SM'] },
  { code: '+239', flag: '🇸🇹', name: 'Sao Tome and Principe', iso: 'ST', aliases: ['ST'] },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia', iso: 'SA', aliases: ['SA'] },
  { code: '+221', flag: '🇸🇳', name: 'Senegal', iso: 'SN', aliases: ['SN'] },
  { code: '+381', flag: '🇷🇸', name: 'Serbia', iso: 'RS', aliases: ['RS'] },
  { code: '+248', flag: '🇸🇨', name: 'Seychelles', iso: 'SC', aliases: ['SC'] },
  { code: '+232', flag: '🇸🇱', name: 'Sierra Leone', iso: 'SL', aliases: ['SL'] },
  { code: '+65', flag: '🇸🇬', name: 'Singapore', iso: 'SG', aliases: ['SG'] },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia', iso: 'SK', aliases: ['SK'] },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia', iso: 'SI', aliases: ['SI'] },
  { code: '+677', flag: '🇸🇧', name: 'Solomon Islands', iso: 'SB', aliases: ['SB'] },
  { code: '+252', flag: '🇸🇴', name: 'Somalia', iso: 'SO', aliases: ['SO'] },
  { code: '+27', flag: '🇿🇦', name: 'South Africa', iso: 'ZA', aliases: ['ZA'] },
  { code: '+82', flag: '🇰🇷', name: 'South Korea', iso: 'KR', aliases: ['KR', 'SOUTH KOREA'] },
  { code: '+211', flag: '🇸🇸', name: 'South Sudan', iso: 'SS', aliases: ['SS'] },
  { code: '+34', flag: '🇪🇸', name: 'Spain', iso: 'ES', aliases: ['ES'] },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka', iso: 'LK', aliases: ['LK'] },
  { code: '+249', flag: '🇸🇩', name: 'Sudan', iso: 'SD', aliases: ['SD'] },
  { code: '+597', flag: '🇸🇷', name: 'Suriname', iso: 'SR', aliases: ['SR'] },
  { code: '+46', flag: '🇸🇪', name: 'Sweden', iso: 'SE', aliases: ['SE'] },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland', iso: 'CH', aliases: ['CH'] },
  { code: '+963', flag: '🇸🇾', name: 'Syria', iso: 'SY', aliases: ['SY'] },
  { code: '+886', flag: '🇹🇼', name: 'Taiwan', iso: 'TW', aliases: ['TW'] },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan', iso: 'TJ', aliases: ['TJ'] },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania', iso: 'TZ', aliases: ['TZ'] },
  { code: '+66', flag: '🇹🇭', name: 'Thailand', iso: 'TH', aliases: ['TH'] },
  { code: '+670', flag: '🇹🇱', name: 'Timor-Leste', iso: 'TL', aliases: ['TL'] },
  { code: '+228', flag: '🇹🇬', name: 'Togo', iso: 'TG', aliases: ['TG'] },
  { code: '+676', flag: '🇹🇴', name: 'Tonga', iso: 'TO', aliases: ['TO'] },
  { code: '+1868', flag: '🇹🇹', name: 'Trinidad and Tobago', iso: 'TT', aliases: ['TT'] },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia', iso: 'TN', aliases: ['TN'] },
  { code: '+90', flag: '🇹🇷', name: 'Turkey', iso: 'TR', aliases: ['TR'] },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan', iso: 'TM', aliases: ['TM'] },
  { code: '+1649', flag: '🇹🇨', name: 'Turks and Caicos Islands', iso: 'TC', aliases: ['TC'] },
  { code: '+688', flag: '🇹🇻', name: 'Tuvalu', iso: 'TV', aliases: ['TV'] },
  { code: '+1340', flag: '🇻🇮', name: 'U.S. Virgin Islands', iso: 'VI', aliases: ['VI'] },
  { code: '+256', flag: '🇺🇬', name: 'Uganda', iso: 'UG', aliases: ['UG'] },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine', iso: 'UA', aliases: ['UA'] },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates', iso: 'AE', aliases: ['AE', 'UAE', 'DUBAI', 'EMIRATES'] },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom', iso: 'GB', aliases: ['GB', 'UK', 'BRITAIN', 'ENGLAND'] },
  { code: '+1', flag: '🇺🇸', name: 'United States', iso: 'US', aliases: ['US', 'USA', 'AMERICA'] },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay', iso: 'UY', aliases: ['UY'] },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan', iso: 'UZ', aliases: ['UZ'] },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu', iso: 'VU', aliases: ['VU'] },
  { code: '+379', flag: '🇻🇦', name: 'Vatican City', iso: 'VA', aliases: ['VA'] },
  { code: '+58', flag: '🇻🇪', name: 'Venezuela', iso: 'VE', aliases: ['VE'] },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam', iso: 'VN', aliases: ['VN'] },
  { code: '+967', flag: '🇾🇪', name: 'Yemen', iso: 'YE', aliases: ['YE'] },
  { code: '+260', flag: '🇿🇲', name: 'Zambia', iso: 'ZM', aliases: ['ZM'] },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabwe', iso: 'ZW', aliases: ['ZW'] },
];

// dedupe by code+name
export const UNIQUE_CODES = COUNTRY_CODES.filter((v, i, a) => a.findIndex(x => x.code === v.code && x.name === v.name) === i);
